<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Usuários' btnLink='$back' btnTxt='Voltar'
        :action="isEdit ? `Editar ${user.name}` : 'Novo'"/>

      <div class="row">
        <div class="col-lg-12">
          <div class="wrapper wrapper-content animated fadeIn">

            <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

            <div class="ibox">
              <div class="ibox-title">
                <h5> Cadastro de Usuário <small class="required-advice"/> </h5>
              </div>

              <div class="ibox-content">
                <div class="row">
                  <form role="form">

                    <div class="col-lg-12">

                      <div class="row">

                        <div class="col-lg-12">
                          <div v-if="isEdit" class="form-group">
                            <label class="control-label" for="id">ID</label>
                            <input id="id" name="id" class="form-control" :value="user.id" disabled readonly>
                          </div>

                          <div class="form-group required">
                            <label class="control-label" for="Email" :class="{invalid: errors.has('Email')}"> Email </label>
                            <input id="Email" type="email" name="Email" class="form-control" placeholder="usuario@email.com" autocomplete="email"   v-model="user.email" v-validate="'required|email'" :class="{ invalid: errors.has('Email') }">
                            <span class="error">{{ errors.first('Email') }}</span>
                            <p v-if="!isEdit" class="help-block">Enviaremos um convite para esse email.</p>
                          </div>

                          <div class="form-group">
                            <label class="control-label" for="Nome"> Nome </label>
                            <input id="Nome" type="text" class="form-control" name="Nome" placeholder="Nome completo" v-model="user.name"
                              v-validate="{ required: true, min: 4, regex: /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/ }"
                              :class="{ invalid: errors.has('Nome') }">
                            <span class="error">{{ errors.first('Nome') }}</span>
                            <p class="help-block">O usuário poderá alterar posteriormente.</p>
                          </div>
                        </div>
                      </div>

                    </div>
                  </form>
                </div>
                <div class="row">
                  <div class="col-sm-12">

                    <button class="btn btn-w-m btn-success pull-right"
                      @click.prevent="saveUser()" :disabled="disabled">
                      <i class="fa fa-save"></i> Salvar
                    </button>

                    <button class="btn btn-w-m btn-primary pull-right"
                      style="margin-right: 5px;" v-if="isEdit"
                      @click.prevent="resendEnvite()" :disabled="disabled">
                      <i class="fa fa-envelope"></i> Reenviar Convite
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <page-footer></page-footer>

    </div>

  </div>
</template>

<script>

import NavMenu from './layout/NavMenu'
import SideMenu from './layout/SideMenu'
import BreadCrumps from './layout/BreadCrumps'
import PageFooter from './layout/PageFooter'
import Multiselect from 'vue-multiselect'
import PaginationLinks from './PaginationLinks'
import ListFilter from './ListFilter'
import Spinner from './layout/Spinner'

import { httpService } from '../providers/http-service'
import { helper } from '../mixins/helper'
import { toast } from '../mixins/toast'
import { errorMessage } from '../mixins/error-message'
import { permissions } from '../mixins/permissions'

export default {
  mixins: [ toast, helper, permissions, errorMessage ],
  components: { NavMenu, SideMenu, BreadCrumps, PageFooter, Multiselect, PaginationLinks, ListFilter, Spinner },
  data () {
    return {
      isEdit: false,
      disabled: false,
      showSpinner: false,
      user: { name: '', email: '' }
    }
  },
  methods: {

    saveUser () {
      this.disable = true
      return this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.showSpinner = true
          const user = { public_key: this.user.public_key, email: this.user.email, name: this.user.name ? this.user.name : this.user.email }

          const action = this.isEdit ? httpService.editUser(user) : httpService.saveNewUser(user)

          const successMessage = this.isEdit ? 'Usuário alterado com sucesso!' : 'Usuário cadatrado com sucesso!'

          return action.then((res) => {
            if (!this.isEdit) { this.sendUserEnvite() }

            this.user = { name: '', email: '' }
            this.resetForm()
            this.disable = false
            this.showSpinner = false
            this.show_toast('success', 'OK', successMessage)

            this.$validator.reset()

            if (this.isEdit) { this.$router.push('/users') }

            return res
          }).catch(err => {
            this.showErrorMessage({ err: err })
          })
        } else {
          this.disable = false
          this.showSpinner = false
          this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
          this.$validator.validateAll()
          setTimeout(() => {
            this.errors.clear()
          }, 3500)
        }
      })
    },

    resendEnvite () {
      this.checkPermissions('', '0053d6310971f7162b1fbcba81647685', 'Enviar convite')
        .then((isPermited) => {
          if (isPermited) { this.sendUserEnvite() }
        })
    },

    sendUserEnvite () {
      this.showSpinner = true
      this.disable = true
      httpService.sendUserEnvite(this.user.email).then((resp) => {
        if (resp.status == 200) {
          this.showSpinner = false
          this.disable = false
          this.show_toast('success', 'Convite Enviado', 'Convite enviado para ' + this.user.email + ' com sucesso!')
        }
      }).catch((err) => {
        this.showSpinner = false
        this.disable = false
        this.show_toast('error', 'Erro', 'Não foi possível enviar o convite, tente editar mais tarde!')
      })
    }
  },

  mounted () {
    if (Object.keys(this.$route.query).length !== 0) {
      this.isEdit = true
      this.user = this.$route.query
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/UserCreatePage.vue